import React from 'react';

const DividerElement = ({ element }) => {
  const { content } = element;
  const { 
    style = 'solid', 
    width = '100%', 
    color = 'default', 
    spacing = 'medium' 
  } = content || {};
  
  const marginMap = { 
    small: '1rem 0', 
    medium: '2rem 0', 
    large: '3rem 0' 
  };
  
  const dividerColor = color === 'default' ? 'var(--color-border)' : color;
  
  return (
    <hr 
      className="builder-divider" 
      style={{ 
        borderStyle: style, 
        borderColor: dividerColor, 
        width, 
        margin: marginMap[spacing] || marginMap.medium 
      }} 
    />
  );
};

export default DividerElement;
